<div class="plan-header-area">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <div class="l-wrap">
        <div class="l-wrap__inner">
          <div *ngIf="!isUnsaved">
            <!-- プラン名称 -->
            <h2 *ngIf="planHeaderAreaData.planName" class="c-heading-2">
              {{ planHeaderAreaData.planName }}
            </h2>
            <div class="info-block">
              <!-- プラン作成日 -->
              <span
                class="info-block__date"
                [innerHTML]="
                  'label.createdOn'
                    | staticMsg : { '0': planHeaderAreaData.createdOn ?? '' | dateFormat : 'default_apiDate' }
                "
              ></span>
              <span class="info-block__divider"></span>
              <!-- プラン有効期限 -->
              <span
                class="info-block__date"
                [innerHTML]="
                  'label.saveUntil'
                    | staticMsg : { '0': planHeaderAreaData.saveUntil ?? '' | dateFormat : 'default_apiDate' }
                "
              ></span>
            </div>
          </div>
          <!-- 差分強調表示凡例 -->
          <div *ngIf="isPlanChanged && isPlanValid" class="info-block">
            <span>
              <img
                class="p-top-saved-plan__note-icon"
                src="{{ appConstants.IMG.R01_P040_S01_U__ICON_CHANGED_18 }}"
                width="18"
                height="18"
                alt
              />
            </span>

            <!-- WCAG規定により、凡例は読み上げ対象外 -->
            <span aria-hidden="true" [innerHTML]="'reader.diffIcon' | staticMsg"></span>
          </div>
          <!-- 無効識別子 -->
          <div *ngIf="!isPlanValid" class="info-block">
            <span class="c-tag c-tag--type05">
              <strong [innerHTML]="'label.flightInvalid2' | staticMsg"></strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
